var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentSpecificationForm',{ref:"contentSpecificationForm",on:{"previewRequested":_vm.onPreviewRequested,"languageChanged":_vm.onLanguageChanged,"formatChanged":_vm.onFormatChanged}}),_c('VideoContentPreview',{ref:"videoContentPreview",attrs:{"formats":_vm.formats,"active-language":_vm.activeLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }